<mat-dialog-content class="custom-reminder-dialog-wrapper">
  <section>
    <h2 class="cmn-popup-title">
      {{reminderId ? 'Update Custom Reminder' : 'Create Custom Reminder'}}
    </h2>
    <button class="cmn-close" mat-dialog-close></button>
    <div class="container">
      <form [formGroup]="createReminderForm" *ngIf="createReminderForm">
        <div class="chart-account-form-wrapper">
          <div class="form-wrapper">
            <label for="">Title<span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                placeholder="Enter title"
                formControlName="title"
              />
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('title')!.invalid && createReminderForm.get('title')!.touched"
                  class="error"
                >
                  Title is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Description<span class="red">*</span></label>
            <mat-form-field>
              <textarea
                matInput
                placeholder="Enter description"
                formControlName="description"
              ></textarea>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('description')!.invalid && createReminderForm.get('description')!.touched"
                  class="error"
                >
                  Description is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Target Type<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Target Type" formControlName="targetType">
                <mat-option *ngFor="let target of targetType" [value]="target">
                  {{ target }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('targetType')!.invalid && createReminderForm.get('targetType')!.touched"
                  class="error"
                >
                  Target Type is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper" *ngIf="createReminderForm.get('targetType')?.value">
            <label for="">Select {{createReminderForm.get('targetType')?.value}}<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Target" formControlName="targetId">
                <mat-option>
                  <ngx-mat-select-search
                    [placeholderLabel]="'Search'"
                    [noEntriesFoundLabel]="'No options found'"
                    (input)="onSearch($event)"
                  ></ngx-mat-select-search>
                </mat-option>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'User' || createReminderForm.get('targetType')?.value ==='Customer'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.firstName + " " + target.lastName }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Vendor'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.vendorName }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Lead'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.leadName }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Task'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.taskName }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Quote'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.quoteCode }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Project'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.projectName }}  
                  </mat-option>
                </div>
                <div *ngIf="createReminderForm.get('targetType')?.value === 'Invoice'">
                  <mat-option *ngFor="let target of targetValues" [value]="target.id">
                    {{ target.invoiceNo }}  
                  </mat-option>
                </div>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('targetId')!.invalid && createReminderForm.get('targetId')!.touched"
                  class="error"
                >
                  Target ID is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Channel<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Channel Type" formControlName="channel">
                <mat-option *ngFor="let channel of channelType" [value]="channel">
                  {{ channel }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('channel')!.invalid && createReminderForm.get('channel')!.touched"
                  class="error"
                >
                  Channel is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Priority<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Priority Type" formControlName="priority">
                <mat-option *ngFor="let priority of priorityType" [value]="priority">
                  {{ priority }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('priority')!.invalid && createReminderForm.get('priority')!.touched"
                  class="error"
                >
                  Priority is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Reminder Type<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Reminder Mode" formControlName="reminderType">
                <mat-option *ngFor="let reminder of reminderType" [value]="reminder">
                  {{ reminder }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('reminderType')!.invalid && createReminderForm.get('reminderType')!.touched"
                  class="error"
                >
                  Reminder Type is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper">
            <label for="">Reminder Status<span class="red">*</span></label>
            <mat-form-field>
              <mat-select placeholder="Select Status Type" formControlName="reminderStatus">
                <mat-option *ngFor="let status of statusType" [value]="status">
                  {{ status }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('reminderStatus')!.invalid && createReminderForm.get('reminderStatus')!.touched"
                  class="error"
                >
                  Reminder Status is required.
                </mat-error>
              </span>
            </div>
          </div>
          <div class="form-wrapper" *ngIf="createReminderForm.get('reminderType')?.value==='OneTime'">
            <label for="">Due At<span class="red">*</span></label>
            <div class="date-time-wrapper">
              <label for="">Date<span class="red">*</span></label>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="duePicker"
                  placeholder="Select Due Date"
                  formControlName="dueAtDate"
                  [min]="minDate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="duePicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #duePicker></mat-datepicker>
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="createReminderForm.get('dueAtDate')!.invalid && createReminderForm.get('dueAtDate')!.touched"
                    class="error"
                  >
                    Due Date is required.
                  </mat-error>
                </span>
              </div>
              <label for="">Time<span class="red">*</span></label>
              <mat-form-field>
                <input
                  matInput
                  type="time"
                  placeholder="Select Due Time"
                  formControlName="dueAtTime"
                />
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="createReminderForm.get('dueAtTime')!.invalid && createReminderForm.get('dueAtTime')!.touched"
                    class="error"
                  >
                    Due Time is required.
                  </mat-error>
                </span>
              </div>
            </div>
          </div>
          <div class="form-wrapper" *ngIf="createReminderForm.get('reminderType')?.value==='Recurring'">
            <label for="">Start At<span class="red">*</span></label>
            <div class="date-time-wrapper">
              <label for="">Date<span class="red">*</span></label>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="startPicker"
                  placeholder="Select Start Date"
                  formControlName="startAtDate"
                  [min]="minDate"
                />
                <mat-datepicker-toggle
                  matIconSuffix
                  [for]="startPicker"
                ></mat-datepicker-toggle>
                <mat-datepicker #startPicker></mat-datepicker>
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="createReminderForm.get('startAtDate')!.invalid && createReminderForm.get('startAtDate')!.touched"
                    class="error"
                  >
                    Start Date is required.
                  </mat-error>
                </span>
              </div>
              <label for="">Time<span class="red">*</span></label>
              <mat-form-field>
                <input
                  matInput
                  type="time"
                  placeholder="Select Start Time"
                  formControlName="startAtTime"
                />
              </mat-form-field>
              <div class="custom-error">
                <span>
                  <mat-error
                    *ngIf="createReminderForm.get('startAtTime')!.invalid && createReminderForm.get('startAtTime')!.touched"
                    class="error"
                  >
                    Start Time is required.
                  </mat-error>
                </span>
              </div>
            </div>
          </div>
          <div class="form-wrapper" *ngIf="createReminderForm.get('reminderType')?.value==='Recurring'">
            <label for="">End At<span class="red">*</span></label>
            <div class="date-time-wrapper">
            <label for="">Date<span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                [matDatepicker]="endPicker"
                placeholder="Select End Date"
                formControlName="endAtDate"
                [min]="minDate"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="endPicker"
              ></mat-datepicker-toggle>
              <mat-datepicker #endPicker></mat-datepicker>
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('endAtDate')!.invalid && createReminderForm.get('endAtDate')!.touched"
                  class="error"
                >
                  End Date is required.
                </mat-error>
              </span>
            </div>
            <label for="">Time<span class="red">*</span></label>
            <mat-form-field>
              <input
                matInput
                type="time"
                placeholder="Select End Time"
                formControlName="endAtTime"
              />
            </mat-form-field>
            <div class="custom-error">
              <span>
                <mat-error
                  *ngIf="createReminderForm.get('endAtTime')!.invalid && createReminderForm.get('endAtTime')!.touched"
                  class="error"
                >
                  End Time is required.
                </mat-error>
              </span>
            </div>
            </div>
          </div>
        </div>
        <div class="submit-btn-wrapper">
          <button class="cmn-cancel-btn" (click)="onCancel()" type="button">
            Cancel
          </button>
          <button class="cmn-next-btn" (click)="onSave()" type="submit">
            Save
          </button>
        </div>
      </form>
    </div>
  </section>
</mat-dialog-content>